<script>
import lazyLoadComponent from '@router/lazyload-component'
import { cloneDeep } from 'lodash'
import { currentQuestionList } from '@utils/pet-question'
import petQ from '@src/mixins/petQ'

const defaultComment = {
  id: '',
  content: '',
}

export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    PetInfoCommentList: () => lazyLoadComponent(import('@components/PetInfoCommentList')),
    OnlySignatureDialog: () => lazyLoadComponent(import('@components/OnlySignatureDialog')),
  },
  mixins: [petQ],
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
    defaultQuestions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      questions: {},
      behavior: [],
      healthy: [],
      latestVaccineDate: '',
      petQuestions: {
        ligation: null,
        register: null,
        chipNumber: '',
        fleaMedicineDate: '',
        vetName: '',
        vetPhone: '',
        vetAddress: '',
      },

      dialogMode: 'edit', // edit 編輯, add 新增， view 預覽
      dialogVisible: false,
      showDetail: false,
      editDetailEnabled: false,
      editPetDetailEnabled: false,
      category: [],
      parentCategoryIndex: 0,
      tryingGet: false,

      defaultData: cloneDeep(this.value),
      isPetCommentEdit: false,
      isPetCommentUpdate: false,
      commentData: cloneDeep(defaultComment),
      tryingSave: false,
      createIng: true,
      signDialogVisible: false, // 確認簽名視窗
      shindenSignType: '',
    }
  },
  computed: {
    imgUrl() {
      if (this.$appType() === 'ipetbooking') {
        return require('@assets/images/pet-avatar-default@2x.png')
      } else {
        return require('@assets/images/person_background.svg')
      }
    },
    submitData: {
      get() {
        // 此為非正常情況：要讓after create後再執行一次return this.value這樣畫面才會更新
        if (!this.createIng > 0) {
          return this.value
        }
        // 正常情況下就return this.value
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    submitQuestionsData: {
      get() {
        return this.defaultQuestions
      },
      set(value) {
        this.$emit('inputQuestions', value)
      },
    },
    submitRules() {
      // const isTaiwan = this.submitData.phoneCode === '+886'
      return {
        avatar: [
          {
            required: true,
            message: '請上傳頭像',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: `請填寫${this.$t('reserve.CLIENT')}名`,
            trigger: 'blur',
          },
        ],
        categoryId: [
          {
            required: true,
            message: '請選擇類別',
            trigger: 'blur',
          },
        ],
        sizeId: [
          {
            required: true,
            message: `請選擇${this.$t('member.BODY_TO_TYPE')}`,
            trigger: 'blur',
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
            trigger: 'change',
          },
        ],
        birthday: [
          {
            required: true,
            message: '請選擇生日',
            trigger: 'blur',
            // trigger: 'change',
          },
        ],
      }
    },
    /**
     * @description 單選組合字
     */
    personalityContent() {
      if (!this.value.questions) return false
      return this.value?.questions?.personality.join('，')
    },
    /**
     * @description 多選組合字
     */
    healthyContent() {
      if (!this.value.questions) return false
      const content = this.value?.questions?.healthy.map((item) => {
        return `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
      })
      return content ? content.join('，') : ''
    },
    behaviorContent() {
      if (!this.value.questions) return false
      const content = this.value?.questions?.behavior.map((item) => {
        return `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
      })
      return content
    },
    vaccineContent() {
      if (!this.value.questions) return false
      let vaccine = ''
      switch (this.value?.questions?.vaccine) {
        case 1:
          vaccine = '1 劑'
          break
        case 2:
          vaccine = '2 劑'
          break
        case 3:
          vaccine = '3 劑'
          break
        default:
          break
      }
      return vaccine
    },
    currentStoreAlias() {
      return this.$store.state.merchant.cached.alias
    },
    isCustomForm() {
      return this.currentStoreAlias === 'glow-headspa' || this.currentStoreAlias === 'shinden'
    },
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.defaultData = cloneDeep(this.value)
      })
    },
    'submitData.categoryId': function() {
      this.getParentCategoryIndex()
    },
    editDetailEnabled: function() {
      this.initPetQuestion()
      this.setDefaultQuestion()
    },
  },
  created() {
    this.tryToFetchCategory()
  },
  mounted() {
    setTimeout(() => {
      this.initPetQuestion()
      this.setDefaultQuestion()
      this.updateValueToQuestions()
    }, 800)
  },
  methods: {
    /**
     * @description 簽名儲存後打上來的string
     */
    updateImgUrl(nvl) {
      if (this.currentStoreAlias !== 'shinden') {
        this.$set(this.submitData.questions, 'signaturStr', nvl)
        return
      }

      const keyMap = {
        hair: 'hairSignaturStr',
        face: 'faceSignaturStr',
        hand: 'handSignaturStr',
      }

      const targetKey = keyMap[this.shindenSignType] || 'signaturStr'
      this.$set(this.submitData.questions, targetKey, nvl)
    },
    updateQuestion() {},
    sign(val) {
      if (this.currentStoreAlias === 'shinden') {
        this.shindenSignType = val
      }

      this.signDialogVisible = true
    },
    initPetQuestion() {
      try {
        const { questions, petQuestions } = this.value

        this.petQuestions = petQuestions ? cloneDeep(petQuestions) : this.petQuestions
        this.targetMappingArray.forEach((item) => {
          if (questions[item] && Array.isArray(questions[item])) {
            this[item] = this.value.questions[item].map((i) => i.title)
          }
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 組成顯示的問題格式
     */
    personalityContentMethods(key) {
      try {
        let textValue = null
        const question = this.value.questions[key]

        if (!question) return '未填寫'
        if (Object.keys(question).length) {
          const text = question.text ? ` ( ${question.text} )` : ''
          textValue = question.title + text
        }
        if (Array.isArray(question) && question.length) {
          textValue = question.map((item) => {
            if (typeof item === 'string') {
              return item
            }

            const text = item.text ? ` ( ${item.text} )` : ''
            let oriText = `${item.title + text}`
            if (item.name === 'pregnant') {
              return `${oriText} 週`
            } else {
              return `${oriText}`
            }
          })
        }
        if (typeof question === 'string') {
          if (this.questions[key]) {
            textValue = this.questions[key].find((item) => {
              return item.name === question
            }).title
          } else {
            textValue = question
          }
        }

        if (Array.isArray(textValue)) {
          return textValue.length ? textValue.join('，') : '未填寫'
        } else {
          return textValue || '未填寫'
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    setDefaultQuestion() {
      try {
        this.targetMappingArray.forEach((key) => {
          if (this.value.questions[key]) {
            this.setItemText(key, this.value.questions[key])
          }
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    setItemText(key, keyVar) {
      try {
        // const question = this.defaultQuestions[key]
        if (Array.isArray(this.defaultQuestions[key])) {
          this.defaultQuestions[key].forEach((item) => {
            if (Array.isArray(keyVar)) {
              const res = keyVar.find((i) => {
                return i.title === item.title
              })
              item.text = res ? res.text : ''
            }
          })
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    async tryToFetchCategory() {
      this.category = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0 })
    },
    backToList() {
      this.$emit('back')
    },
    getParentCategoryIndex() {
      this.category.forEach((item, index) => {
        if (this.submitData.categoryId === item.id) {
          this.parentCategoryIndex = index
        }
      })
    },
    changeCategory() {
      this.submitData.sizeId = ''
    },
    enableEditDetail() {
      const data = {
        isEditEnabled: true,
        type: 'pet',
      }
      this.editDetailEnabled = true
      this.$emit('isEditDetailEnabled', data)
    },
    /**
     * @description 改問題的答案時，要經過此道change程序
     */
    onChangeQ(key) {
      try {
        const question = this[key]

        if (typeof question === 'string') return

        const item = question.map((item) => {
          const selected = this.questions[key].find((i) => {
            return i.title === item
          })
          return selected
        })
        console.log(key)

        this.$set(this.submitData.questions, key, item)
      } catch (error) {
        console.error(error.message)
      }
    },
    // 處理 petQuestions 欄位的更新
    updatePetQuestions() {
      this.$emit('updatePetQuestions', this.petQuestions)
    },
    async onClickRemove(id) {
      // this.tryingList = true
      try {
        await this.$store.dispatch('comment/removeComment', { ids: [id] })
        this.$message({ message: '刪除成功', type: 'success' })
        this.updateValue()
      } finally {
        // this.tryingList = false
      }
    },
    enableEditPetDetail() {
      this.editPetDetailEnabled = true
      this.commentData = cloneDeep(defaultComment)
    },
    async tryToStorePetInfoComment() {
      if (this.isPetCommentUpdate) {
        const { id, content, petId, type } = this.commentData
        await this.$store
          .dispatch('comment/store', {
            type,
            content,
            petId,
            uuid: id,
          })
          .then(() => {
            this.updateValue()
            this.isPetCommentUpdate = false
            this.editPetDetailEnabled = false
          })
      } else {
        const { id } = this.defaultValue
        await this.$store
          .dispatch('comment/store', {
            type: 'pet',
            petId: id,
            content: this.commentData.content,
          })
          .then(() => {
            this.updateValue()
            this.editPetDetailEnabled = false
          })
      }
    },
    closeEditComment() {
      this.isPetCommentUpdate = false
      this.editPetDetailEnabled = false
    },
    updateValue() {
      this.$emit('update')
    },
    editUpdateComment(item) {
      this.editPetDetailEnabled = true
      this.isPetCommentUpdate = true
      this.commentData = { ...item }
    },
    updateValueToQuestions() {
      const incomingQuestions = this.value?.questions || {}
      const isNonEmptyObject = (val) => val && typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length > 0

      this.questions = cloneDeep(currentQuestionList(this.currentStoreAlias))

      this.targetMappingArray.forEach((key) => {
        const base = this.questions[key]
        const incoming = incomingQuestions[key]

        if (Array.isArray(base) && isNonEmptyObject(incoming)) {
          const targetItem = base.find((item) => item.name === incoming.name)
          if (targetItem) {
            targetItem.text = incoming.text
          }
        }
      })
    },
    getPetQuestionData(key) {
      const value = this.petQuestions[key]

      if (typeof value === 'boolean') {
        return value ? '是' : '否'
      }

      if (value) {
        return value
      }
      return '未填寫'
    },
  },
}
</script>

<template>
  <div :class="$style.DetailPets">
    <div>
      <BasePageHeader>
        <template v-slot:title>
          <el-button class="is-round isStyleBase mr-4" @click="backToList">
            <BaseIcon name="arrow-left" />
            返回
          </el-button>
          <span style="vertical-align: middle;">{{ $t('reserve.CLIENT') }}資訊</span>
        </template>
        <template v-slot:right>
          <el-button v-if="!editDetailEnabled" type="primary" class="is-round isStyleBase" @click="enableEditDetail"> 編輯{{ $t('reserve.CLIENT') }}資訊 </el-button>
        </template>
      </BasePageHeader>
    </div>
    <div v-loading="tryingGet" class="isStylePageContent" :class="$style.pet">
      <div class="pet__box">
        <el-form ref="form" :model="submitData" :rules="submitRules" label-position="left" class="el-form--floating" :validate-on-rule-change="false" :label-width="'100px'">
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="pet__avatar">
                <template v-if="editDetailEnabled">
                  <BaseUpload v-model="submitData.avatar" v-loading="tryingGet" resource="pet" circle dir="pet" />
                </template>
                <template v-else>
                  <div :style="{ backgroundImage: submitData.avatar ? `url('${submitData.avatar}')` : `url('${imgUrl}')` }" class="el-upload__img" @click="enableEditDetail">
                    <div class="el-upload__more">
                      <el-button type="primary" class="is-circle">
                        <i class="fal fa-edit"></i>
                      </el-button>
                    </div>
                  </div>
                </template>
              </div>
            </el-col>
            <el-col :span="24">
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">基本資料</h5>
              <template v-if="editDetailEnabled">
                <template>
                  <el-form-item prop="name" :label="`${$t('member.PET_TO_SURNAME')}名`" class="el-form-item--normal-margin">
                    <el-input v-model="submitData.name" :placeholder="`請輸入${$t('reserve.CLIENT')}名`" class="bg-white is-border"></el-input>
                  </el-form-item>
                  <el-form-item label="類別" prop="categoryId" class="el-form-item--normal-margin">
                    <el-select v-model="submitData.categoryId" class="is-border" @change="changeCategory">
                      <el-option v-for="(item, index) in category" :key="index" :value="item.id" :label="item.title"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="`${$t('member.BODY_TO_TYPE')}`" prop="sizeId" class="el-form-item--normal-margin">
                    <el-select v-model="submitData.sizeId" class="is-border">
                      <el-option v-for="(item, index) in category[parentCategoryIndex].children" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="$merchantI18n() === 'pet'" prop="breed" label="品種" class="el-form-item--normal-margin">
                    <el-input v-model="submitData.breed" placeholder="請輸入品種" class="bg-white is-border"></el-input>
                  </el-form-item>
                  <el-form-item label="性別" class="el-form-item--normal-margin">
                    <el-select v-model="submitData.gender" class="is-border">
                      <el-option :label="`${$t('sex.Female')}`" value="female"></el-option>
                      <el-option :label="`${$t('sex.Male')}`" value="male"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="生日" class="el-form-item--normal-margin">
                    <el-date-picker v-model="submitData.birthday" type="date" value-format="yyyy-MM-dd" class="bg-white is-border"></el-date-picker>
                  </el-form-item>
                  <el-form-item v-if="$merchantI18n() === 'beauty' || $merchantI18n() === 'massage'" label="電話" class="el-form-item--normal-margin">
                    <el-input v-model="submitData.phone" :placeholder="`請輸入電話`" class="bg-white is-border"></el-input>
                  </el-form-item>
                </template>
                <template v-if="$merchantI18n() === 'pet'">
                  <el-form-item label="是否結紮" class="el-form-item--normal-margin">
                    <el-radio-group v-model="petQuestions.ligation" @change="updatePetQuestions">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="寵物登記" class="el-form-item--normal-margin">
                    <el-radio-group v-model="petQuestions.register" @change="updatePetQuestions">
                      <el-radio :label="true">有</el-radio>
                      <el-radio :label="false">無</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="晶片號碼" class="el-form-item--normal-margin">
                    <el-input v-model="petQuestions.chipNumber" @input="updatePetQuestions"></el-input>
                  </el-form-item>
                  <el-form-item label="點除蚤藥日期(最近)" class="el-form-item--normal-margin">
                    <el-input v-model="petQuestions.fleaMedicineDate" @input="updatePetQuestions"></el-input>
                  </el-form-item>
                  <h5 class="mb-3 fw-regular">飼主獸醫院</h5>
                  <el-form-item label="獸醫院名稱" class="el-form-item--normal-margin">
                    <el-input v-model="petQuestions.vetName" @input="updatePetQuestions"></el-input>
                  </el-form-item>
                  <el-form-item label="獸醫院電話" class="el-form-item--normal-margin">
                    <el-input v-model="petQuestions.vetPhone" @input="updatePetQuestions"></el-input>
                  </el-form-item>
                  <el-form-item label="獸醫院地址" class="el-form-item--normal-margin">
                    <el-input v-model="petQuestions.vetAddress" @input="updatePetQuestions"></el-input>
                  </el-form-item>
                </template>
              </template>
              <template v-else>
                <div class="pet__info">
                  <el-row>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      {{ $t('member.PET_TO_SURNAME') }}名：<span class="Jost" style="color: #121931">{{ defaultData.name }}</span>
                    </el-col>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      類別：<span class="Jost" style="color: #121931">{{ defaultData.categoryTitle }}</span>
                    </el-col>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      {{ $t('member.BODY_TO_TYPE') }}：<span class="Jost" style="color: #121931">{{ defaultData.sizeTitle }}</span>
                    </el-col>
                    <el-col v-if="$merchantI18n() === 'pet'" :md="12" :span="24" class="pet__info__item">
                      品種：<span class="Jost" style="color: #121931">{{ defaultData.breed }}</span>
                    </el-col>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      性別：
                      <span v-if="defaultData.gender" class="Jost" style="color: #121931">
                        {{ defaultData.gender === 'male' ? `${$t('sex.Male')}` : `${$t('sex.Female')}` }}
                      </span>
                    </el-col>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      生日：<span class="Jost" style="color: #121931">{{ defaultData.birthday }}</span>
                    </el-col>
                    <el-col v-if="$merchantI18n() === 'beauty' || $merchantI18n() === 'massage'" :md="12" :span="24" class="pet__info__item">
                      電話：<span class="Jost" style="color: #121931">{{ defaultData.phone }}</span>
                    </el-col>

                    <template v-if="$merchantI18n() === 'pet'">
                      <el-col :md="12" :span="24" class="pet__info__item">
                        是否結紮：<span class="Jost" style="color: #121931">{{ getPetQuestionData('ligation') }}</span>
                      </el-col>
                      <el-col :md="12" :span="24" class="pet__info__item">
                        是否登記：<span class="Jost" style="color: #121931">{{ getPetQuestionData('register') }}</span>
                      </el-col>
                      <el-col :md="12" :span="24" class="pet__info__item">
                        晶片號碼：<span class="Jost" style="color: #121931">{{ getPetQuestionData('chipNumber') }}</span>
                      </el-col>
                      <el-col :md="12" :span="24" class="pet__info__item">
                        點除蚤藥日期(最近一次)：<span class="Jost" style="color: #121931">{{ getPetQuestionData('fleaMedicineDate') }}</span>
                      </el-col>
                      <el-col :md="12" :span="24" class="pet__info__item">
                        獸醫院名稱：<span class="Jost" style="color: #121931">{{ getPetQuestionData('vetName') }}</span>
                      </el-col>
                      <el-col :md="12" :span="24" class="pet__info__item">
                        獸醫院電話：<span class="Jost" style="color: #121931">{{ getPetQuestionData('vetPhone') }}</span>
                      </el-col>
                      <el-col :md="12" :span="24" class="pet__info__item">
                        獸醫院地址：<span class="Jost" style="color: #121931">{{ getPetQuestionData('vetAddress') }}</span>
                      </el-col>
                    </template>
                  </el-row>
                </div>
                <!-- <div v-else class="pet__info">
                  <el-row>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      {{ $t('member.PET_TO_SURNAME') }}名：<span class="Jost" style="color: #121931">{{ defaultData.name }}</span>
                    </el-col>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      類別：<span class="Jost" style="color: #121931">{{ defaultData.categoryTitle }}</span>
                    </el-col>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      {{ $t('member.BODY_TO_TYPE') }}：<span class="Jost" style="color: #121931">{{ defaultData.sizeTitle }}</span>
                    </el-col>
                    <el-col v-if="$merchantI18n() === 'pet'" :md="12" :span="24" class="pet__info__item">
                      品種：<span class="Jost" style="color: #121931">{{ defaultData.breed }}</span>
                    </el-col>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      性別：
                      <span v-if="defaultData.gender" class="Jost" style="color: #121931">
                        {{ defaultData.gender === 'male' ? `${$t('sex.Male')}` : `${$t('sex.Female')}` }}
                      </span>
                    </el-col>
                    <el-col :md="12" :span="24" class="pet__info__item">
                      生日：<span class="Jost" style="color: #121931">{{ defaultData.birthday }}</span>
                    </el-col>
                    <el-col v-if="$merchantI18n() === 'beauty' || $merchantI18n() === 'massage'" :md="12" :span="24" class="pet__info__item">
                      電話：<span class="Jost" style="color: #121931">{{ defaultData.phone }}</span>
                    </el-col>
                  </el-row>
                </div> -->
              </template>
            </el-col>
          </el-row>
          <!-- 寵物問題 -->
          <div v-if="$merchantI18n() === 'pet'" class="notice">
            <el-divider></el-divider>
            <h5 class="mb-3 fw-regular">{{ $t('reserve.CLIENT') }}問題</h5>
            <!-- 修改模式 -->
            <template v-if="editDetailEnabled">
              <el-form-item label="個性" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.personality">
                  <template v-for="item in questions.personality">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="submitData.questions.personality.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="寵物病史" class="el-form-item--normal-margin">
                <span>飼主應盡告知義務，若因隱瞞病況發生意外或死亡，經法定程序判定店家無疏失，店家不須負損害賠償責任</span>
                <el-checkbox-group v-model="healthy" @change="onChangeQ('healthy')">
                  <template v-for="item in submitQuestionsData.healthy">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="healthy.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" class="bg-white is-border" placeholder="請填寫其他疾病" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="行為" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="behavior" @change="onChangeQ('behavior')">
                  <template v-for="item in submitQuestionsData.behavior">
                    <div :key="item.title" class="inline-checkbox-input">
                      <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                      <el-input v-model="item.text" class="bg-white is-border" />
                    </div>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="疫苗" class="el-form-item--normal-margin">
                <el-radio v-model="submitData.questions.vaccine" :label="1">ㄧ劑</el-radio>
                <el-radio v-model="submitData.questions.vaccine" :label="2">二劑</el-radio>
                <el-radio v-model="submitData.questions.vaccine" :label="3">三劑</el-radio>
                <el-input v-model="submitData.questions.latestVaccineDate" placeholder="最後施打日期"></el-input>
              </el-form-item>
            </template>
            <!-- 觀看模式 -->
            <template v-else>
              <el-row>
                <el-col :md="12" :span="24" class="pet__info__item">
                  個性：<span class="Jost" style="color: #121931">{{ personalityContent ? personalityContent : '未填寫' }}</span>
                </el-col>
                <el-col :md="12" :span="24" class="pet__info__item">
                  健康狀況：<span class="Jost" style="color: #121931">{{ healthyContent ? healthyContent : '未填寫' }}</span>
                </el-col>
                <el-col :md="12" :span="24" class="pet__info__item">
                  行為：
                  <template v-if="behaviorContent.length > 0">
                    <span class="content">
                      <span v-for="n in behaviorContent" :key="n" class="content__item Jost" style="color: #121931">{{ n }}</span>
                    </span>
                  </template>
                  <span v-else class="Jost" style="color: #121931">未填寫</span>
                </el-col>
                <el-col :md="12" :span="24" class="pet__info__item">
                  疫苗：<span class="Jost" style="color: #121931">{{ vaccineContent ? vaccineContent : '未填寫' }}</span>
                </el-col>
              </el-row>
            </template>
          </div>
          <!-- dingbeauty 使用人問題 -->
          <div v-if="$merchantI18n() === 'beauty' && !isCustomForm" class="notice">
            <el-divider></el-divider>
            <h5 class="mb-3 fw-regular">身體狀況</h5>
            <!-- 修改模式 -->
            <template v-if="editDetailEnabled">
              <el-form-item label="備孕/懷孕" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="pregnant" @change="onChangeQ('pregnant')">
                  <template v-for="item in submitQuestionsData.pregnant">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="pregnant.includes('懷孕中') && item.name === 'pregnant'" :key="item.title" v-model="item.text" placeholder="請填寫週數" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="生活狀況" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="livinCondition" @change="onChangeQ('livinCondition')">
                  <template v-for="item in submitQuestionsData.livinCondition">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="livinCondition.includes('喝酒') && item.name === 'drink-wine'" :key="item.title" v-model="item.text" placeholder="請填寫飲酒頻率" />
                    <el-input v-if="livinCondition.includes('熬夜') && item.name === 'stay-up'" :key="item.title" v-model="item.text" placeholder="請填寫睡眠時間" />
                    <el-input v-if="livinCondition.includes('飲料、咖啡') && item.name === 'coffee'" :key="item.title" v-model="item.text" placeholder="請填寫飲用頻率" />
                    <el-input v-if="livinCondition.includes('藥物') && item.name === 'drug'" :key="item.title" v-model="item.text" placeholder="請填寫藥物" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="健康狀態" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="healthStatus" @change="onChangeQ('healthStatus')">
                  <template v-for="item in submitQuestionsData.healthStatus">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="healthStatus.includes('便秘問題') && item.name === 'constipation'" :key="item.title" v-model="item.text" placeholder="請填寫便秘頻率" />
                    <el-input v-if="healthStatus.includes('月經失調') && item.name === 'menstrual-irregularity'" :key="item.title" v-model="item.text" placeholder="請填寫月經週期" />
                    <el-input v-if="healthStatus.includes('睡眠困擾') && item.name === 'insomnia'" :key="item.title" v-model="item.text" placeholder="請填寫困擾事項" />
                    <el-input v-if="healthStatus.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫健康狀態" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="肌膚狀態" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="skinCondition" @change="onChangeQ('skinCondition')">
                  <template v-for="item in submitQuestionsData.skinCondition">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="skinCondition.includes('特定成分過敏') && item.name === 'specific-ingredient-allergy'" :key="item.title" v-model="item.text" placeholder="請填寫過敏成分" />
                    <el-input v-if="skinCondition.includes('其他肌膚問題') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫肌膚問題" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">肌膚狀況</h5>
              <el-form-item label="有無開刀史" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="historyOfSurgery" @change="onChangeQ('historyOfSurgery')">
                  <template v-for="item in submitQuestionsData.historyOfSurgery">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="historyOfSurgery.includes('有') && item.name === 'yes'" :key="item.title" v-model="item.text" placeholder="請填寫部位" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="膚質" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="skinType" @change="onChangeQ('skinType')">
                  <template v-for="item in submitQuestionsData.skinType">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="skinType.includes('敏感問題') && item.name === 'sensitive'" :key="item.title" v-model="item.text" placeholder="請填寫敏感部位/成分" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="防曬狀況" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="sunProtectionStatus" @change="onChangeQ('sunProtectionStatus')">
                  <template v-for="item in submitQuestionsData.sunProtectionStatus">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="防曬習慣" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="sunProtectionHabits" @change="onChangeQ('sunProtectionHabits')">
                  <template v-for="item in submitQuestionsData.sunProtectionHabits">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="sunProtectionHabits.includes('備註') && item.name === 'remark'" :key="item.title" v-model="item.text" placeholder="請填寫備註" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="卸妝產品類型" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="makeupRemoverType" @change="onChangeQ('makeupRemoverType')">
                  <template v-for="item in submitQuestionsData.makeupRemoverType">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="makeupRemoverType.includes('備註') && item.name === 'remark'" :key="item.title" v-model="item.text" placeholder="請填寫備註" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="使用的保養品" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="skinCareProductsUsed" @change="onChangeQ('skinCareProductsUsed')">
                  <template v-for="item in submitQuestionsData.skinCareProductsUsed">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="skinCareProductsUsed.includes('果酸') && item.name === 'fruit-acid'" :key="item.title" v-model="item.text" placeholder="請填寫果酸類型" />
                    <el-input v-if="skinCareProductsUsed.includes('備註') && item.name === 'remark'" :key="item.title" v-model="item.text" placeholder="請填寫備註" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="醫美療程" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="recentMedicalTreatment" @change="onChangeQ('recentMedicalTreatment')">
                  <template v-for="item in submitQuestionsData.recentMedicalTreatment">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="recentMedicalTreatment.includes('療程名稱') && item.name === 'name'" :key="item.title" v-model="item.text" placeholder="請填寫療程名稱" />
                    <el-input v-if="recentMedicalTreatment.includes('日期') && item.name === 'date'" :key="item.title" v-model="item.text" placeholder="請填寫日期" />
                  </template>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="希望解決的肌膚問題" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="skinProblemYouWantToSolve" @change="onChangeQ('skinProblemYouWantToSolve')">
                  <template v-for="item in submitQuestionsData.skinProblemYouWantToSolve">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="skinProblemYouWantToSolve.includes('備註') && item.name === 'remark'" :key="item.title" v-model="item.text" placeholder="請填寫備註" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">簽名確認</h5>
              <el-button @click="sign">簽名確認</el-button>
            </template>
            <!-- 觀看模式 -->
            <template v-else>
              <el-row>
                <el-col v-for="item in bodyConditionForBeauty" :key="item.key" :md="12" :span="24" class="pet__info__item">
                  {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">肌膚狀況</h5>
              <el-row>
                <el-col v-for="item in skinConditionDemo" :key="item.key" :md="12" :span="24" class="pet__info__item">
                  {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">客戶簽名</h5>
              <div style="margin-bottom:20px">
                <template v-if="submitData.questions.signaturStr">
                  <el-image :src="submitData.questions.signaturStr" :class="$style.image" />
                </template>
                <div v-else slot="error"> 圖片載入失敗 </div>
              </div>
            </template>
          </div>
          <!-- 使用人問題 觀看模式 -->
          <div v-if="$merchantI18n() === 'massage' && !editDetailEnabled" class="notice">
            <el-divider></el-divider>
            <h5 class="mb-3 fw-regular">身體狀況</h5>
            <el-row>
              <el-col v-for="item in bodyConditionForMassage" :key="item.key" :md="12" :span="24" class="pet__info__item">
                {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
              </el-col>
            </el-row>
          </div>

          <!-- glow 使用人問題 -->
          <div v-if="$merchantI18n() === 'beauty' && currentStoreAlias === 'glow-headspa'" class="notice">
            <el-divider></el-divider>
            <h5 class="mb-3 fw-regular">其他資訊</h5>
            <template v-if="editDetailEnabled">
              <el-form-item label="婚姻狀況" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.marriage">
                  <template v-for="item in questions.marriage">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="居住地址" class="el-form-item--normal-margin">
                <el-input v-model="submitData.questions.homeAddress" placeholder="請填寫地址"></el-input>
              </el-form-item>
              <el-form-item label="電子信箱" class="el-form-item--normal-margin">
                <el-input v-model="submitData.questions.email" placeholder="請填寫地址"></el-input>
              </el-form-item>
              <el-form-item label="是否希望DM郵件" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.DM">
                  <template v-for="item in questions.DM">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="職業" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.job">
                  <template v-for="item in questions.job">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                    <el-input v-if="job === 'other' && item.name === 'other'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫職業" class="mt-3"></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="工作地址" class="el-form-item--normal-margin">
                <el-input v-model="submitData.questions.workingAddress" placeholder="請填寫地址"></el-input>
              </el-form-item>
              <el-form-item label="來店契機" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="reasons">
                  <template v-for="item in questions.reasons">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="reasons.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
            </template>
            <template v-if="!editDetailEnabled">
              <el-row>
                <el-col v-for="item in memberInfoForGlow" :key="item.key" :md="12" :span="24" class="pet__info__item">
                  {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                </el-col>
              </el-row>
            </template>
            <el-divider></el-divider>
            <h5 class="mb-3 fw-regular">GLOW 顧客諮詢紀錄卡</h5>
            <!-- 修改模式 -->
            <template v-if="editDetailEnabled">
              <el-form-item label="健康狀態" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="healthStatus" @change="onChangeQ('healthStatus')">
                  <template v-for="item in submitQuestionsData.healthStatus">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="healthStatus.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫健康狀態" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="體質/疾病" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="disease" @change="onChangeQ('disease')">
                  <template v-for="item in submitQuestionsData.disease">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="disease.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫病名" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="近期壓力狀況" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="pressure" @change="onChangeQ('pressure')">
                  <template v-for="item in submitQuestionsData.pressure">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="是否會過敏" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="allergy" @change="onChangeQ('allergy')">
                  <template v-for="item in submitQuestionsData.allergy">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="allergy.includes('有') && item.name === 'yes'" :key="item.title" v-model="item.text" placeholder="請填寫過敏原" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="服用藥物" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="medicine" @change="onChangeQ('medicine')">
                  <template v-for="item in submitQuestionsData.medicine">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="medicine.includes('其他醫生開立之處方籤') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫藥物名稱" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="睡眠品質" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="sleepQuality" @change="onChangeQ('sleepQuality')">
                  <template v-for="item in submitQuestionsData.sleepQuality">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="飲食習慣" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="eatingHabits" @change="onChangeQ('eatingHabits')">
                  <template v-for="item in submitQuestionsData.eatingHabits">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="eatingHabits.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item label="來店主要目的" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="purposes" @change="onChangeQ('purposes')">
                  <template v-for="item in submitQuestionsData.purposes">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="purposes.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="近期頭皮狀況" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="scalpProblemRecently" @change="onChangeQ('scalpProblemRecently')">
                  <template v-for="item in submitQuestionsData.scalpProblemRecently">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="scalpProblemRecently.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="近期頭髮狀況" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="hairProblem" @change="onChangeQ('hairProblem')">
                  <template v-for="item in submitQuestionsData.hairProblem">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="hairProblem.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="洗髮頻率" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="hairWashFrequency" @change="onChangeQ('hairWashFrequency')">
                  <template v-for="item in submitQuestionsData.hairWashFrequency">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="hairWashFrequency.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="頭皮出油狀況" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="oilyScalpProblem" @change="onChangeQ('oilyScalpProblem')">
                  <template v-for="item in submitQuestionsData.oilyScalpProblem">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="頭皮屑狀況" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="dandruffProblem" @change="onChangeQ('dandruffProblem')">
                  <template v-for="item in submitQuestionsData.dandruffProblem">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="過去頭皮狀況" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="scalpProblemPast" @change="onChangeQ('scalpProblemPast')">
                  <template v-for="item in submitQuestionsData.scalpProblemPast">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="過去使用洗護產品類型" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="hairCareProducts" @change="onChangeQ('hairCareProducts')">
                  <template v-for="item in submitQuestionsData.hairCareProducts">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="hairCareProducts.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="曾接受專業頭皮護理" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="hasScalpCareService" @change="onChangeQ('hasScalpCareService')">
                  <template v-for="item in submitQuestionsData.hasScalpCareService">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="hasScalpCareService.includes('是') && item.name === 'yes'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">簽名確認</h5>
              <el-button @click="sign">簽名確認</el-button>
            </template>
            <!-- 觀看模式 -->
            <template v-if="!editDetailEnabled">
              <el-row>
                <el-col v-for="item in bodyConditionForGlow" :key="item.key" :md="12" :span="24" class="pet__info__item">
                  {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row>
                <el-col v-for="item in customerHistoryForGlow" :key="item.key" :md="12" :span="24" class="pet__info__item">
                  {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">客戶簽名</h5>
              <div style="margin-bottom:20px">
                <template v-if="submitData.questions.signaturStr">
                  <el-image :src="submitData.questions.signaturStr" :class="$style.image" />
                </template>
                <div v-else slot="error"> 圖片載入失敗 </div>
              </div>
            </template>
          </div>

          <!-- 心傳使用人問題 -->
          <div v-if="$merchantI18n() === 'beauty' && currentStoreAlias === 'shinden'" class="notice">
            <el-divider></el-divider>
            <template v-if="editDetailEnabled">
              <h5>淨毛諮詢診療紀錄卡</h5>
              <el-form-item label="請在您認為合適的選項打勾" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.medicalHistory">
                  <template v-for="item in submitQuestionsData.medicalHistory">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <!-- <el-input v-if="submitData.questions.medicalHistory.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" /> -->
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="正在接受疾病治療嗎？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.curingForHair">
                  <template v-for="item in questions.curingForHair">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.curingForHair.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫病名"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="正在服用藥物嗎？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.medicationStatusForHair">
                  <template v-for="item in questions.medicationStatusForHair">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="健康狀態如何?" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.healthStatusForHair">
                  <template v-for="item in questions.healthStatusForHair">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.healthStatusForHair.name === 'poor' && item.name === 'poor'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生理期狀態如何？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.menstrualPeriodStatusForHair">
                  <template v-for="item in questions.menstrualPeriodStatusForHair">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.menstrualPeriodStatusForHair.name === 'none' && item.name === 'none'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="以前有過皮膚問題嗎？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.skinProblemsForHair">
                  <template v-for="item in questions.skinProblemsForHair">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.skinProblemsForHair.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否曾進行或預定進行大型手術？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.majorSurgery">
                  <template v-for="item in questions.majorSurgery">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.majorSurgery.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否曾進行醫美手術或正在恢復期？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.cosmeticSurgeryForHair">
                  <template v-for="item in questions.cosmeticSurgeryForHair">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.cosmeticSurgeryForHair.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否曾經或將要接受陽光曝曬？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.sunExposureForHair">
                  <template v-for="item in questions.sunExposureForHair">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.sunExposureForHair.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否曾經接受淨毛手術？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.hairRemovalSurgery">
                  <template v-for="item in questions.hairRemovalSurgery">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.hairRemovalSurgery.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="自行處理的方式是？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.selfHairRemoval">
                  <template v-for="item in questions.selfHairRemoval">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.selfHairRemoval.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="您在意的部位是？" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.bodyParts">
                  <template v-for="item in submitQuestionsData.bodyParts">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="submitData.questions.bodyParts.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="本次來店的契機？" class="el-form-item--normal-margin">
                <el-input v-model="reasonsForShinden" placeholder="請輸入"></el-input>
              </el-form-item>
              <el-form-item label="施術的關注點？" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.focus">
                  <template v-for="item in submitQuestionsData.focus">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="submitData.questions.focus.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">簽名確認</h5>
              <el-button @click="sign('hair')">簽名確認</el-button>
              <el-divider></el-divider>
              <h5>『淨 kiyo』臉部諮詢紀錄卡</h5>
              <el-form-item label="健康狀態如何?" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.healthStatusForFace">
                  <template v-for="item in questions.healthStatusForFace">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.healthStatusForFace.name === 'poor' && item.name === 'poor'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生理期狀態如何？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.menstrualPeriodStatusForFace">
                  <template v-for="item in questions.menstrualPeriodStatusForFace">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.menstrualPeriodStatusForFace.name === 'irregular' && item.name === 'irregular'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生理痛狀態如何？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.menstrualPainForFace">
                  <template v-for="item in questions.menstrualPainForFace">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.menstrualPainForFace.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="過敏狀態如何？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.allergyForFace">
                  <template v-for="item in questions.allergyForFace">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.allergyForFace.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否有治療中疾病？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.curingForFace">
                  <template v-for="item in questions.curingForFace">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.curingForFace.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否有服用藥物？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.medicationStatusForFace">
                  <template v-for="item in questions.medicationStatusForFace">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.medicationStatusForFace.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否佩戴隱形眼鏡？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.contactLenses">
                  <template v-for="item in questions.contactLenses">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否接受陽光曝曬？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.sunExposureForFace">
                  <template v-for="item in questions.sunExposureForFace">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否接受過其他醫美服務？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.otherMedicalBeautyForFace">
                  <template v-for="item in questions.otherMedicalBeautyForFace">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.otherMedicalBeautyForFace.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="曾做過臉部美容手術或正在術後恢復嗎？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.cosmeticSurgeryForFace">
                  <template v-for="item in questions.cosmeticSurgeryForFace">
                    <el-radio :key="item.name" :label="item" class="mb-3">{{ item.title }}</el-radio>
                    <el-input v-if="submitData.questions.cosmeticSurgeryForFace.name === 'yes' && item.name === 'yes'" :key="`${item.name}-input`" v-model="item.text" placeholder="請填寫"></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="進行過雷射美容嗎？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.laserBeauty">
                  <template v-for="item in questions.laserBeauty">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.laserBeauty.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="曾有過皮膚問題嗎？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.skinProblemsForFace">
                  <template v-for="item in questions.skinProblemsForFace">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.skinProblemsForFace.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="日常肌膚管理？" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.skinCareProducts">
                  <template v-for="item in submitQuestionsData.skinCareProducts">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="submitData.questions.skinCareProducts.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="使用過美顏儀器嗎？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.beautyEquipment">
                  <template v-for="item in questions.beautyEquipment">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.beautyEquipment.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="肌膚問題" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.skinProblemsSelectForFace">
                  <template v-for="item in submitQuestionsData.skinProblemsSelectForFace">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="submitData.questions.skinProblemsSelectForFace.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">簽名確認</h5>
              <el-button @click="sign('face')">簽名確認</el-button>
              <el-divider></el-divider>
              <h5>『淨』日式純手技諮詢紀錄卡</h5>
              <el-form-item label="健康狀態如何?" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.healthStatusForHand">
                  <template v-for="item in questions.healthStatusForHand">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.healthStatusForHand.name === 'poor' && item.name === 'poor'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生理期狀態如何？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.menstrualPeriodStatusForHand">
                  <template v-for="item in questions.menstrualPeriodStatusForHand">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.menstrualPeriodStatusForHand.name === 'irregular' && item.name === 'irregular'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生理痛狀態如何？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.menstrualPainForHand">
                  <template v-for="item in questions.menstrualPainForHand">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.menstrualPainForHand.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="壓力狀態如何？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.pressureStatus">
                  <template v-for="item in questions.pressureStatus">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.pressureStatus.name === 'other' && item.name === 'other'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="體質" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.constitution">
                  <template v-for="item in submitQuestionsData.constitution">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="submitData.questions.constitution.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫原因" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="是否有治療中疾病？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.curingForHand">
                  <template v-for="item in questions.curingForHand">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.curingForHand.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="過敏狀態如何？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.allergyForHand">
                  <template v-for="item in questions.allergyForHand">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.allergyForHand.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否有服用藥物？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.medicationStatusForHand">
                  <template v-for="item in questions.medicationStatusForHand">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.medicationStatusForHand.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="起床時間" class="el-form-item--normal-margin">
                <div class="d-flex">
                  <el-input v-model="submitData.questions.wackUpTime" />
                  <span class="ml-2">點</span>
                </div>
              </el-form-item>
              <el-form-item label="就寢時間" class="el-form-item--normal-margin">
                <div class="d-flex">
                  <el-input v-model="submitData.questions.sleepTime" />
                  <span class="ml-2">點</span>
                </div>
              </el-form-item>
              <el-form-item label="睡眠狀態" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.sleepStatus">
                  <template v-for="item in questions.sleepStatus">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="休假" class="el-form-item--normal-margin">
                <div class="d-flex">
                  <span class="mr-2" style="width: 40px">一週</span>
                  <el-input v-model="submitData.questions.holidays" />
                  <span class="ml-2">日</span>
                </div>
              </el-form-item>
              <el-form-item label="活動" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.activities">
                  <template v-for="item in questions.activities">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否有懷孕可能？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.preparingForPregnancy">
                  <template v-for="item in questions.preparingForPregnancy">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.preparingForPregnancy.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫月數"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="身高" class="el-form-item--normal-margin">
                <div class="d-flex">
                  <el-input v-model="submitData.questions.height" />
                  <span class="ml-2" style="width: 40px">cm</span>
                </div>
              </el-form-item>
              <el-form-item label="體重" class="el-form-item--normal-margin">
                <div class="d-flex">
                  <el-input v-model="submitData.questions.weight" />
                  <span class="ml-2" style="width: 40px">kg</span>
                </div>
              </el-form-item>
              <el-form-item label="飲食習慣" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.eatingStatus">
                  <template v-for="item in questions.eatingStatus">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="飲食" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.eatingHabits">
                  <template v-for="item in questions.eatingHabits">
                    <el-radio :key="item.name" :label="item.name">{{ item.title }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="嗜好" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.hobby">
                  <template v-for="item in submitQuestionsData.hobby">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="身體煩惱" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.healthProblemsForHand">
                  <template v-for="item in submitQuestionsData.healthProblemsForHand">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="submitData.questions.healthProblemsForHand.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="肌膚問題" class="el-form-item--normal-margin">
                <el-checkbox-group v-model="submitData.questions.skinProblemsForHand">
                  <template v-for="item in submitQuestionsData.skinProblemsForHand">
                    <el-checkbox :key="item.name" :label="item.title">{{ item.title }}</el-checkbox>
                    <el-input v-if="submitData.questions.skinProblemsForHand.includes('其他') && item.name === 'other'" :key="item.title" v-model="item.text" placeholder="請填寫" />
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="是否去過他家美容院？" class="el-form-item--normal-margin">
                <el-radio-group v-model="submitData.questions.otherMedicalBeautyForHand">
                  <template v-for="item in questions.otherMedicalBeautyForHand">
                    <el-radio :key="item.name" :label="item">{{ item.title }}</el-radio>
                    <el-input
                      v-if="submitData.questions.otherMedicalBeautyForHand.name === 'yes' && item.name === 'yes'"
                      :key="`${item.name}-input`"
                      v-model="item.text"
                      placeholder="請填寫"
                      class="mt-3"
                    ></el-input>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="每月美容消費" class="el-form-item--normal-margin">
                <div class="d-flex">
                  <span class="mr-2" style="width: 20px">約</span>
                  <el-input v-model="submitData.questions.beautyExpenses" />
                  <span class="ml-2">元</span>
                </div>
              </el-form-item>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">簽名確認</h5>
              <el-button @click="sign('hand')">簽名確認</el-button>
            </template>
            <template v-if="!editDetailEnabled">
              <h5>淨毛諮詢診療紀錄卡</h5>
              <el-row>
                <el-col v-for="item in shindenForHair" :key="item.key" :md="12" :span="24" class="pet__info__item">
                  {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">客戶簽名</h5>
              <div style="margin-bottom:20px">
                <template v-if="submitData.questions.hairSignaturStr">
                  <el-image :src="submitData.questions.hairSignaturStr" :class="$style.image" />
                </template>
                <div v-else slot="error"> 圖片載入失敗 </div>
              </div>
              <el-divider></el-divider>
              <h5>『淨 kiyo』臉部諮詢紀錄卡</h5>
              <el-row>
                <el-col v-for="item in shindenForFace" :key="item.key" :md="12" :span="24" class="pet__info__item">
                  {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">客戶簽名</h5>
              <div style="margin-bottom:20px">
                <template v-if="submitData.questions.faceSignaturStr">
                  <el-image :src="submitData.questions.faceSignaturStr" :class="$style.image" />
                </template>
                <div v-else slot="error"> 圖片載入失敗 </div>
              </div>
              <el-divider></el-divider>
              <h5>『淨』日式純手技諮詢紀錄卡</h5>
              <el-row>
                <el-col v-for="item in shindenForHand" :key="item.key" :md="12" :span="24" class="pet__info__item">
                  {{ item.text }}：<span class="Jost" style="color: #121931">{{ personalityContentMethods(item.key) }}</span>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <h5 class="mb-3 fw-regular">客戶簽名</h5>
              <div style="margin-bottom:20px">
                <template v-if="submitData.questions.handSignaturStr">
                  <el-image :src="submitData.questions.handSignaturStr" :class="$style.image" />
                </template>
                <div v-else slot="error"> 圖片載入失敗 </div>
              </div>
            </template>
          </div>

          <div class="notice">
            <el-divider></el-divider>
            <h5 class="mb-3 fw-regular d-flex justify-content-between align-items-center">
              {{ $t('member.PET_TO_SKIN') }}備註
              <el-button v-if="!editPetDetailEnabled" type="primary" class="is-round isStyleBase" @click="enableEditPetDetail"> 新增{{ $t('member.PET_TO_SKIN') }}備註 </el-button>
            </h5>
            <template v-if="editPetDetailEnabled">
              <el-form-item label="" label-width="0">
                <el-input v-model="commentData.content" type="textarea" :rows="5" class="bg-white is-border"></el-input>
                <div class="btn-group-inline mt-5">
                  <el-button class="is-round" @click="closeEditComment">取消</el-button>
                  <el-button :loading="tryingSave" :disabled="tryingSave" class="is-round" type="primary" @click="tryToStorePetInfoComment">儲存</el-button>
                </div>
              </el-form-item>
            </template>
            <template v-else>
              <PetInfoCommentList v-if="defaultValue.petComments" :default-value="defaultValue.petComments.items" @edit="editUpdateComment" @remove="onClickRemove" />
            </template>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 簽名請款 -->
    <OnlySignatureDialog
      :one-step="true"
      :dialog-title="`簽名確認`"
      :start-tab="2"
      :visible.sync="signDialogVisible"
      @update="updateQuestion"
      @closeSignature="signDialogVisible = false"
      @updateImgUrl="updateImgUrl"
    />
  </div>
</template>

<style lang="scss" module>

.DetailPets {
  padding: 1.68rem 1rem 0;

  @include max-md {
    padding: 1rem 1rem 0;
  }
}

.el-form-item__content {
  margin-left: 0;
}

.petListImg {
  border-radius: 100%;
  overflow: hidden;
  height: 70px;
  width: 70px;
  text-align: center;
}

.pet {
  // font-size: 18px;
  :global {
    .danger {
      color: $color-state-danger;
    }

    .top {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }

    .pet {
      &__back {
        cursor: pointer;
      }

      &__box {
        margin-bottom: 30px;
      }

      &__info {
        &__item {
          margin-bottom: 12px;
        }
      }
    }

    .notice {
      margin-bottom: 30px;

      h5 {
        font-size: 18px;
      }

      line-height: 1.5;
    }

    .el-upload {
      &__img {
        width: 140px;
        height: 140px;
        background-color: #eee;
        background-position: center;
        background-size: cover;
        border-radius: 100%;
        opacity: 1;
        transition: opacity 0.3s;
        position: relative;
        margin: 0 auto;
        cursor: pointer;

        &:hover {
          opacity: 0.85;
        }
      }

      &__more {
        position: absolute;
        right: 0;
        bottom: 0;
        border: 3px solid #fff;
        border-radius: 100%;
        letter-spacing: 0;

        button {
          padding: 0;
          width: 40px;
          height: 40px;
        }

        i {
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>
